(() => {
  if (window.blhCopyLinkBound) return;
  window.blhCopyLinkBound = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-blh-copy-link]');
    if (!button) return;
    const url = button.dataset.blhCopyLink;
    const status = button.closest('.blh-share')?.querySelector('[role="status"]');
    if (!status) return;
    clearTimeout(button.blhCopyTimeout);
    try {
      await navigator.clipboard.writeText(url);
      status.textContent = button.dataset.successMessage;
      button.blhCopyTimeout = setTimeout(() => {
        status.textContent = '';
      }, 2500);
    } catch {
      status.textContent = 'Unable to copy. Please copy the page address from your browser.';
    }
  });
})();
